export default __webpack_public_path__ + "static/media/litoibarra.4eeaaa13.png";